import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ModalController, AlertController, NavController, ToastController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import { Project } from '../../models/Project';
import { ProjectService } from '../../providers/project-service/project-service';
import { InstitutionService } from 'src/app/providers/institution-service/institution-service';
import { Institution } from 'src/app/models/Institution';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';

import { load, unload } from "@finapi/web-form";
import { HttpClient } from '@angular/common/http';
import { Integration } from 'src/app/models/Integration';
import { IntegrationService } from 'src/app/providers/integration-service/integration-service';

import { Observable } from 'rxjs';
import { AuthService } from 'src/app/providers/auth-service/auth-service';
import { NotificationMessage } from 'src/app/components/notification-message/notification-message.component';
import { TranslationBridge } from 'src/app/providers/translation-bridge/translation-bridge';
import { ConnectedInstitution } from 'src/app/models/ConnectedInstitution';

// @ts-ignore
declare var window: any;

@Component({
  selector: 'app-quick-sync',
  templateUrl: './quick-sync.page.html',
  styleUrls: ['./quick-sync.page.scss'],
  host: {
    'class': 'accent-page connect-page'
  }
})
export class QuickSyncPage implements OnInit {

  initializing: boolean = true;
  project: Project;
  integration: Integration;

  messages: NotificationMessage[] = [];
  
  connectionStep: string = "init";
  modalStep: string = "loading";
  dryRun: boolean = true;

  project$: Observable<Project>;

  outdatedAccounts: any = [];
  latestImport: any = null;

  connectModalOpen: boolean = false;
  institutionsLoading: boolean = true;
  connectedInstitutions: ConnectedInstitution[] = [];


  webformId: string = "";
  embedWebForm: boolean = environment.finAPIEmbedding;
  @ViewChild('webFormContainer') webformContainer: any;

  checkBailout: number = 0;
  checkInterval: any;

  constructor(
    public auth: AuthService,
    public modalController: ModalController,
    public alertController: AlertController,
    public projectService: ProjectService,
    public institutionService: InstitutionService,
    public integrationService: IntegrationService,
    public translate: TranslationBridge,
    private activatedRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private renderer: Renderer2,
    private toastController: ToastController,
    private http: HttpClient,
    private navCtrl: NavController) {}

  ngOnInit() {
    let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
    let integrationId = this.activatedRoute.snapshot.paramMap.get('integrationId');
    this.projectService.isReady().then(()=>{
        if(projectId){
          let currentProject = this.projectService.getCurrentProject();
          if(!currentProject || currentProject.id != projectId){
            this.projectService.setCurrentProject(projectId).then(()=>{
              this.project = this.projectService.getCurrentProject();
              this.integration = this.project.integrations.find((integration) => integration.id == integrationId);
              if(this.integration){
                
                this.connectionStep = "init";
                this.integration.syncStatus = "";

                setTimeout(() => {
                  this.checkOutdatedAccounts();
                }, 1000);
              } else {
                this.noAccess();
              }
              this.initializing = false;
            }).catch((err)=>{
              console.log("Error setting current project: ", err);
              this.initializing = false;
              this.noAccess();
            });
          } else {
            this.project = this.projectService.getCurrentProject();
            this.integration = this.project.integrations.find((integration) => integration.id == integrationId);
            if(this.integration){
              this.integration.syncStatus = "";
              this.connectionStep = "init";
              setTimeout(() => {
                this.checkOutdatedAccounts();
              }, 1000);
            } else {
              this.noAccess();
            }
            this.initializing = false;
          }
        } else {
          this.initializing = false;
          this.noAccess();
        } 
    }); 
  }

  /*
    1. Maybe we want to update accounts first
  */
  checkOutdatedAccounts(){
    // check connected accounts
    let accounts = this.projectService.getCachedAccounts();
    if(accounts.length > 0){

      accounts.forEach((account)=>{
      
        if(account.interfaces && account.interfaces.length > 0){
          account.interfaces.forEach((intf: any)=>{

            // determine the latest import
            if(intf.lastSuccessfulUpdate){
              try {
                let lastImport = new Date(intf.lastSuccessfulUpdate);
                if(!this.latestImport || lastImport > this.latestImport){
                  this.latestImport = lastImport;
                }
              } catch (e){
                console.log("Error parsing date: ", e);
              }
            }
          });
        }
      
      });


      this.outdatedAccounts = this.institutionService.getOutdatedAccountsFromList(accounts);
      if(this.outdatedAccounts.length > 0){
        this.connectionStep = "requireAuth";
        this.messages = [];
        this.messages.push({
          type: "warning",
          icon: "bank",
          title: "Bankkonten",
          text: this.translate.get("SYNC_MESSAGES_OUTDATED_ACCOUNTS").replace("$COUNT",this.outdatedAccounts.length),
          actionTitle: this.translate.get("SYNC_MESSAGES_OUTDATED_ACCOUNTS_ACTION"),
          action: () => {
            this.openConnectModal();
          }
        });
      } else {
        this.connectionStep = "requireAuth";

        //this.startSync();
      }
    }
  }

  /*
    2. Schedule the Sync
  */
  startSync(){
    this.messages = [];

    // @ts-ignore
    if(!this.projectService.isProjectActive()){
      this.connectionStep = "error";
      this.integration.syncStatus = "error";
     
      this.messages.push({
        type: "danger",
        icon: "bank",
        title: "Bankkonten",
        text: this.translate.get("SYNC_MESSAGES_SUBSCRIPTION_INACTIVE"),
        actionTitle: null,
        action: null
      });
     
      return;
    }

    if(!this.integration.active){
      this.connectionStep = "error";
      this.integration.syncStatus = "error";

      this.messages.push({
        type: "warning",
        icon: "power",
        title: "Integration",
        text: this.translate.get("SYNC_MESSAGES_INTEGRATION_INACTIVE"),
        actionTitle: null,
        action: null
      });
     

      return;
    }
    this.integration.syncStatus = "starting";
    this.integration.syncLog = {
      status: "starting",
      logs: [],
      date: new Date(),
      items: 0
    };
    
    this.dryRun = false;

    this.integrationService.manualSyncIntegration(this.integration.id).then((result)=>{
      setTimeout(() => {
        this.checkSync();
      }, 1000);
    }).catch((err)=>{
      console.log("Error starting manual sync: ", err);
      this.connectionStep = "error";
      this.messages.push({
        type: "danger",
        icon: "warning",
        title: "Bankkonten",
        text: this.translate.get("SYNC_MESSAGES_ERROR_START"),
        actionTitle: null,
        action: null
      });
    });

    this.connectionStep = "scheduled";

  }

  noAccess(){
    this.connectionStep = "error";
    this.messages = [];
    this.messages.push({
      type: "danger",
      icon: "link-break",
      title: "Bankkonten",
      text: this.translate.get("SYNC_MESSAGES_NO_ACCESS"),
      actionTitle: null,
      action: null
    });
    console.log("NO ACCESS");
  }

  checkSync(){
    this.project$ = this.projectService.getProjectByIdSub(this.project.id);
    this.project$.subscribe((project)=>{
      console.log("project update");
      this.project = project;
      this.integration = this.project.integrations.find((integration) => integration.id == this.integration.id);
      if(this.connectionStep != "init" && (this.integration.syncStatus == "error" || this.integration.syncStatus == "failed")){
        this.messages = [];
        this.messages.push({
          type: "danger",
          icon: "warning",
          title: "Bankkonten",
          text: this.translate.get("SYNC_MESSAGES_SYNC_FAILED"),
          actionTitle: null,
          action: null
        });
      }
      if(this.connectionStep != "init" && (this.integration.syncStatus == "success")){
        this.messages = [];
        if(this.integration.syncLog.items > 0){
          this.messages.push({
            type: "primary",
            icon: "confetti",
            title: "Bankkonten",
            text: this.translate.get("SYNC_MESSAGES_SYNC_NEW_TRANSACTIONS").replace("%COUNT%",this.integration.syncLog.items),
            actionTitle: null,
            action: null
          });
        } else {
          this.messages.push({
            type: "primary-light",
            icon: "confetti",
            title: "Bankkonten",
            text: this.translate.get("SYNC_MESSAGES_SYNC_SUCCESS_EMPTY"),
            actionTitle: null,
            action: null
          });
        }
      }


    });
  }


  /*
    Connect Modal
  */
  async openConnectModal(){

    this.destroyWebform();
    this.modalStep = "loading";
    this.connectModalOpen = true;

    this.institutionsLoading = true;
    let result = await this.institutionService.getConnectedInstitutions(this.projectService.getCurrentProjectId());
    this.connectedInstitutions = result.connections;
    this.institutionsLoading = false;
    this.modalStep = "list";

  }

  async updateConnection(connection: ConnectedInstitution){
    let projectId = this.projectService.getCurrentProjectId();
    let institutionId = connection.id;

    this.modalStep = "webform";

    this.webformId = "";

    let res = await this.institutionService.updateInstitutionConnection(institutionId, projectId, false);

    this.checkInterval = setInterval(() => {
      this.checkUpdateProgres(institutionId);
      this.checkBailout++;
      if(this.checkBailout > 20) {
        clearInterval(this.checkInterval);
        this.toastController.create({
          message: 'Update failed. Please try again.',
          duration: 4000,
          cssClass: 'toast-error'
        });  
        this.openConnectModal();
      }
    }, 3500);
  }

  async checkUpdateProgres(institutionId: number){
    let projectId = this.projectService.currentProject.id;
    let res = await this.institutionService.getConnectedInstitutionById(institutionId,projectId);

    // @ts-ignore check if we need a webform
    let webformNeeded = res.interfaces.find(i => i.userActionRequired == true);
    if(webformNeeded){
 
      // @ts-ignore
      const webformId = await this.institutionService.getUpdateWebformFromAccounts(res.accounts);

      if(webformId){ 
        clearInterval(this.checkInterval);
        this.webformId = webformId;
        this.createWebForm();
      } else {
        clearInterval(this.checkInterval);
        this.toastController.create({
          message: 'Update failed. Please try again.',
          duration: 4000,
          cssClass: 'toast-error'
        });  
        this.openConnectModal();
      }
    }

  }

   /*
     EMBEDDED WEBFORM
   */
   createWebForm() {
      return new Promise(async (resolve, reject) => {
        let target = this.webformContainer.nativeElement;
        if (!target) return;
        
        let webformCSS = await this.http.get('/assets/webform.css', { responseType: 'text' }).toPromise();
        
        console.log("webform-id", this.webformId,           {
          token: this.webformId,
          targetUrl: environment.finapiWebformBase,
          layoutConfig: "xs",
        });

        load(
          target,
          {
            token: this.webformId,
            targetUrl: environment.finapiWebformBase,
            layoutConfig: "xs",
          },
          {
            onComplete: async () => {
              await this.projectService.updateCachedAccounts();
              this.checkOutdatedAccounts();
              this.openConnectModal();
            },
            onFail: () => {
            },
            onAbort: () => {
              this.openConnectModal();
            },
            onLoadError: () => {
              reject({ error: "loadError" });
            },
            onLoaded: () => {
              const style = this.renderer.createElement('style');
              style.innerText = webformCSS;
              this.renderer.appendChild(this.webformContainer.nativeElement.getElementsByTagName('finapi-webform2-webcomponent')[0].shadowRoot, style);
              resolve(true);
            }
          }
        );
  
      });
  
    }
  
    destroyWebform(){
      this.webformId = "";      
      let target = this.webformContainer?.nativeElement;
      if (!target) return;
      unload(this.webformContainer.nativeElement);
    }
  

  closeConnectModal(){
    this.connectModalOpen = false;
  }
  async onConnectModalClosed(){
    this.connectModalOpen = false;
    await this.projectService.updateCachedAccounts();
    this.checkOutdatedAccounts();
  }

  canCloseWindow(){

    // @ts-ignore
    if(window.opener != null || window.history.length == 1){
      return true;
    } else {
      return false;
    }
  }

  closeWindow(){
    // @ts-ignore
    window.close('','_parent','');
  }

}
